// parseLaunchParams разбирает параметры поиска
export function parseLaunchParams() {
    const result = {};
    new URLSearchParams(window.location.search).forEach((value, key) => {
        result[key] = value;
    });

    return result;
}
